import { createFileRoute } from "@tanstack/react-router"
import { InviteEmployee } from "modules/settings/components/Team/InviteEmployee"

export const Route = createFileRoute("/_base/_auth/settings/team/invite")({
  component: InviteEmployee,
})
